import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoMdArrowRoundBack } from "react-icons/io";

function ContactUsPage() {
    const navigate = useNavigate();
    return (
        <Fragment>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12 section-title-row cart-title-row ms-0 m-1'>
                        <div className='d-flex align-items-center'>
                            <button
                                onClick={() => navigate(-1)}
                                className="cart-back-btn"
                                aria-label="Go back"
                            >
                                <IoMdArrowRoundBack size={22} color="#333" />
                            </button>
                            <h5 style={{ margin: 0, marginLeft: '0.5rem' }}>CONTACT US</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-12 col-md-12 col-sm-12 col-12 p-4'>
                        <h5>Best Basket – Bareilly</h5>
                        
                        <p>
                            <strong>Phone:</strong><br/>
                            +91 98370 12345
                        </p>
                        <p>
                            <strong>Email:</strong><br/>
                            support@bestbasket.in
                        </p>
                        <p>
                            <strong>Working Hours:</strong><br/>
                            24/7
                        </p>
                        
                        <div style={{
                            background: 'linear-gradient(135deg, #1a365d 0%, #2d5a87 100%)',
                            padding: '20px',
                            borderRadius: '8px',
                            marginTop: '30px',
                            border: '2px solid #f7d794'
                        }}>
                            <p style={{
                                color: '#f7d794',
                                fontWeight: '500',
                                margin: '0',
                                fontSize: '0.95rem',
                                lineHeight: '1.5'
                            }}>
                                Best Basket is committed to providing reliable grocery delivery services in Bareilly. 
                                Contact information provided is for customer support purposes only. 
                                We strive to respond to all inquiries within 24 hours during business operations.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ContactUsPage;
